export default __webpack_public_path__ + "static/winuall-beeb250bd477f19cb53ce237f0a8403d.png";